import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppDispatch } from '../../../store/store';
import { Box, CircularProgress, Typography } from '@mui/material';
import { exchangeGBPFetchTokenAction, exchangeGBPTokenAction } from '../../../redux/actions/AuthActionsNew';
import { routes } from '../../../utils/routes';

const GoogleBusinessImportSuccess = ({ isgbp }: { isgbp: boolean }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const hasCalledAPI = useRef(false);

    const workspaceId = localStorage.getItem("activeWorkspaceId")

    useEffect(() => {
        // Extract tokens immediately to avoid stale closures
        const bridgeToken = searchParams.get('bridge_token');
        const tokenData = searchParams.get('token_data');
        const code = searchParams.get('code');


        // Prevent multiple API calls
        if (hasCalledAPI.current) {
            return;
        }

        // for fecth google business for Check-ins
        if (isgbp) {
            if (bridgeToken && code && workspaceId) {
                hasCalledAPI.current = true;

                dispatch(exchangeGBPFetchTokenAction({ bridge_token: bridgeToken, code: code, workspaceId: workspaceId || "" }))
                    .unwrap()
                    .then((res) => {
                        if (res.success) {
                            navigate(routes?.mapCheckingDashboard, { state: { isModalOpen: true }, replace: true });
                        } else {
                            navigate(routes.dashboard, { replace: true });
                        }
                    })
                    .catch((e) => {
                        console.error("API Error:", e);
                        hasCalledAPI.current = false; // Reset on error to allow retry
                        navigate(routes.mapCheckingDashboard, { replace: true });
                    });
            } else {
                navigate(routes.mapCheckingDashboard, { replace: true });
            }
        }
        // for fecth google business for import business
        else {
            if (bridgeToken && tokenData && workspaceId) {
                hasCalledAPI.current = true;


                dispatch(exchangeGBPTokenAction({ bridge_token: bridgeToken, token_data: tokenData, workspaceId: workspaceId }))
                    .unwrap()
                    .then((res) => {
                        if (res.success) {
                            navigate(routes?.manageLocalBusiness, { state: { isModalOpen: true }, replace: true });
                        } else {
                            navigate(routes.dashboard, { replace: true });
                        }
                    })
                    .catch((e) => {
                        console.error("API Error:", e);
                        hasCalledAPI.current = false; // Reset on error to allow retry
                        navigate(routes.dashboard, { replace: true });
                    });
            } else {
                navigate(routes.dashboard, { replace: true });
            }
        }


    }, [searchParams, navigate, dispatch]);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f4f6f8',
            }}
        >
            <CircularProgress size={60} thickness={5} />
            <Typography mt={2} variant="h6" sx={{ color: '#555' }}>
                Authenticating...
            </Typography>
        </Box>
    )
}

export default GoogleBusinessImportSuccess